import { lazy } from 'react';

// Optimized with webpackPrefetch hint for faster loading
export const LazyLogin = lazy(() => 
  import(/* webpackPrefetch: true */ '@/pages/Login')
);
